import {useContext, useEffect, useState} from "react";
import {Button, ButtonGroup, Chip, Typography} from "@mui/material";
import AuthContext from "../Services/AuthContext";
import Main from "../Layout/Main";
import {
    createTableColumn,
    DataGrid,
    DataGridBody,
    DataGridCell,
    DataGridHeader,
    DataGridHeaderCell,
    DataGridRow
} from "@fluentui/react-components";
import {useNavigate, useParams} from "react-router-dom";
import {Edit, PersonAdd, Delete} from "@mui/icons-material";
import ImportPriority from "../Panel/Season/ImportPriority";
import AddPriority from "../Panel/Season/AddPriority";
import EditOrganizer from "../Panel/Organizer/EditOrganizer";
import AddUserRole from "../Panel/Organizer/AddUserRole";

function OrganizerSettings() {
    const [user] = useContext(AuthContext);
    const params = useParams();
    const [users, setUsers] = useState([]);
    const [organizer, setOrganizer] = useState({name: ''});
    const [addUser, setAddUser] = useState(false);
    const [editOrganizer, setEditOrganizer] = useState(false);
    const [refresh, setRefresh] = useState(0);

    const navigate = useNavigate();
    useEffect(() => {
        if (user.token === "") {
            navigate("/");
        }
    }, [user.token, navigate]);

    useEffect(() => {
        const abortController = new AbortController();
        async function fetchData() {
            const url = `/api/organizer/${params.id}`;
            await fetch(url, {
                method: 'GET',
                signal: abortController.signal,
                headers: {
                    'Authorization': 'Bearer ' + user.token
                }
            }).then(res => res.json())
                .then(data => {
                    setUsers(data.users);
                    setOrganizer(data.organizer);
                })
                .catch(err => {
                    console.log(err)
                })
        }
        fetchData();
        return () => abortController.abort();
    }, [params, user.token, refresh]);

    const actions = <ButtonGroup>
        <Button variant={'contained'} startIcon={<PersonAdd />} onClick={() => setAddUser(organizer.id)}>Dodaj Konto</Button>
        <Button variant={'contained'} color={'success'} startIcon={<Edit />} onClick={() => setEditOrganizer(organizer)}>Edytuj Dane</Button>
    </ButtonGroup>;

    const _delete = (id) => {
        fetch(`/api/user/role/${id}`, {
            method: 'DELETE',
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(res => res.json())
            .then(data => {
                setRefresh((r) => ++r);
            })
            .catch(err => { console.log(err) })
    }
    const columns = [
        createTableColumn ({
            columnId: "email",
            renderHeaderCell: () => {
                return "Email";
            },
            renderCell: (item) => {
                const isActive = !item.active ? <Chip color={'warning'} label="Nieaktywny" /> : '';
                return (<>{isActive}{item.email}</>);
            }
        }),
        createTableColumn ({
            columnId: "name",
            renderHeaderCell: () => {
                return "Imię";
            },
            renderCell: (item) => {
                return item.name;
            }
        }),
        createTableColumn ({
            columnId: "surname",
            renderHeaderCell: () => {
                return "Nazwisko";
            },
            renderCell: (item) => {
                return item.surname;
            }
        }),
        createTableColumn ({
            columnId: "role",
            renderHeaderCell: () => {
                return "Rola";
            },
            renderCell: (item) => {
                return item.organizer_id === null ? 'Administrator' : 'Organizator';
            }
        }),
        createTableColumn ({
            columnId: "actions",
            renderHeaderCell: () => {
                return "Akcje";
            },
            renderCell: (item) => {
                return <Button variant={'outlined'} color={'error'} onDoubleClick={() => _delete(item.id)}><Delete /></Button>;
            }
        })
    ];

    return (
        <Main title={'Organizator: ' + organizer.name} actions={actions}>
            <Typography variant="body2" component="p">{organizer.address}</Typography>
            <Typography variant="body2" component="p">tel: {organizer.phone}</Typography>
            <Typography variant="body2" component="p">email: {organizer.email}</Typography>
            <DataGrid
                items={users}
                columns={columns}
                sortable
                getRowId={(item) => item.id}
                focusMode="composite"
                style={{minWidth: "95vw"}}
            >
                <DataGridHeader>
                    <DataGridRow>
                        {({renderHeaderCell}) => (
                            <DataGridHeaderCell>{renderHeaderCell()}</DataGridHeaderCell>
                        )}
                    </DataGridRow>
                </DataGridHeader>
                <DataGridBody>
                    {({item, rowId}) => (
                        <DataGridRow key={rowId}>
                            {({renderCell}) => (
                                <DataGridCell>{renderCell(item)}</DataGridCell>
                            )}
                        </DataGridRow>
                    )}
                </DataGridBody>
            </DataGrid>
            <AddUserRole data={addUser} dismiss={() => setAddUser(false)} onSuccess={() => setRefresh(r => ++r)} />
            <EditOrganizer data={editOrganizer} dismiss={() => setEditOrganizer(false)} onSuccess={() => setRefresh(r => ++r)} />
        </Main>
    );
}

export default OrganizerSettings;